// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"206":"943480d5","406":"7486c440"}[chunkId] + ".js";
};